import React from 'react'
import { Sidebar2 } from '../sidebarcom/Sidebar2'
// import SideBar from '../sidebar/SideBar'
// import Featured from './Featured'

import "../../styles/global.css"

// import About from './About'
const Dashboard = () => {
  
  return (
    <>
    {/* <div>Dashboard</div> */}
    {/* <SideBar />
    <Featured /> */}

    <Sidebar2 />
    
 
 {/* <div className=''>
 <About/>
 </div> */}

    </>
  )
}

export default Dashboard